import Swiper, { Autoplay, Navigation, Pagination, EffectFade,Thumbs } from "swiper";

document.addEventListener('DOMContentLoaded', function() {
	const items = document.querySelectorAll('.slider-fullscreen .swiper-slide');
	const fullscreenSlider = new Swiper(".swiper-container", {
		slidesPerView: 1,
		modules: [Autoplay, Navigation, Pagination, EffectFade],
		speed: 500,
		loop: true,
		watchOverflow: true,
		enabled: items.length > 1,
		autoplay: {
			delay: 5000,
		},
		effect: 'fade',
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			disabledClass: 'swiper-button-disabled',
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	const thumbnails = document.querySelectorAll(".section-slider-thumbnail-nav .swiper-slide");
	var swiper = new Swiper(".section-slider-thumbnail-nav", {
		spaceBetween: 10,
		slidesPerView: thumbnails.length,
		modules: [Autoplay, Navigation, Pagination, EffectFade,Thumbs],
		freeMode: true,
		watchSlidesProgress: true,
	});
	
	var swiper2 = new Swiper(".section-slider", {
		spaceBetween: 10,
		speed: 1000,
		autoplay: {
			delay: 5000,
		},
		modules: [Autoplay, Navigation, Pagination, EffectFade,Thumbs],
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		thumbs: {
			swiper: swiper,
		},
	});
});



